module.exports = __webpack_public_path__ + "static/media/elcano_3.c877481c.png";